import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

// Components
import Navbar from "./Components/Navbar/Navbar";
import NmdFooter from "./Components/Footer/NmdFooter";
import ScrollToTop from "./Components/ScrollToTop";
import LeftSocialIcons from "./Components/LeftSocialIcons/LeftSocialIcons";

// Main Pages
import Home from "./Pages/Home";
import About from "./Pages/About";
import OurServices from "./Pages/OurServices";
import Contact from "./Pages/Contact";
import Blogs from "./Pages/Blogs";

// Dropdown Pages
import AppDevelopment from "./Pages/Dropdown/AppDevelopment";
import GameDevelopment from "./Pages/Dropdown/GameDevelopment";
import DataScience from "./Pages/Dropdown/DataScience";
import BusinessConsulting from "./Pages/Dropdown/BusinessConsulting";
import DataAnalysis from "./Pages/Dropdown/DataAnalysis";
import DigitalMarketing from "./Pages/Dropdown/DigitalMarketing";

// Blog Components
import BlogsCards from "./Components/BlogsCards/BlogsCards";
import BlogDetailWrapper from "./Components/BlogsCards/BlogDetailWrapper"; // Wrapper for dynamic blog detail

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Navbar />
      <LeftSocialIcons />

      <Routes>
        {/* Main Pages */}
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<OurServices />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/blogs" element={<Blogs />} />

        {/* Blogs Overview */}
        <Route path="/blogs/cards" element={<BlogsCards />} />

        {/* ⭐ SINGLE BLOG DETAIL ROUTE (dynamic with :id) ⭐ */}
        <Route path="/blogs/:id" element={<BlogDetailWrapper />} />

        {/* Dropdown Pages */}
        <Route path="/services/app-development" element={<AppDevelopment />} />
        <Route path="/services/game-development" element={<GameDevelopment />} />
        <Route path="/services/data-science" element={<DataScience />} />
        <Route path="/services/business-consulting" element={<BusinessConsulting />} />
        <Route path="/services/data-analysis" element={<DataAnalysis />} />
        <Route path="/services/digital-marketing" element={<DigitalMarketing />} />
      </Routes>

      <NmdFooter />
    </Router>
  );
}

export default App;
